import React from 'react';
import LocationTemplate from './LocationTemplate';

const HertfordPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Hertford"
      stateName="North Carolina"
      countyName="Perquimans"
      zipCodes={["27944"]}
      latitude={36.1901}
      longitude={-76.4660}
      population={2067}
      historicalFact="County seat of Perquimans County, established in 1758 and named after Hertford, England."
      nearbyTowns={[
        "Elizabeth City, NC",
        "Edenton, NC",
        "Winfall, NC",
        "Chowan, NC",
        "Camden, NC",
        "South Mills, NC",
        "Manteo, NC",
        "Great Bridge, VA"
      ]}
    />
  );
};

export default HertfordPage;